module.exports = __webpack_public_path__ + "static/media/gery-s-35.ff53e1ef.png";